import { FadeUp } from "@/components/ui/animated";

export function Quote() {
  return (
    <figure className="mx-auto flex max-w-3xl flex-col items-center px-4 py-12 text-center">
      <FadeUp>
        <blockquote className="text-3xl leading-[1.1] font-medium tracking-tighter text-balance md:text-5xl md:text-wrap">
          <span>The week makes more sense when the record is honest.</span>
          {/* The template's second tone, held where it still reads on paper. */}
          <span className="text-foreground/85">
            {" "}
            Vessa keeps the messy parts without turning them into a verdict.
          </span>
        </blockquote>
      </FadeUp>
      <figcaption className="mt-10 flex flex-col items-center gap-4">
        <FadeUp delay={0.15}>
          <span className="block font-semibold tracking-tight md:text-xl">
            Built for clearer conversations with your care team
          </span>
        </FadeUp>
      </figcaption>
    </figure>
  );
}
